import { render, staticRenderFns } from "./xi-check.vue?vue&type=template&id=8b153c8e&scoped=true"
import script from "./xi-check.vue?vue&type=script&lang=js"
export * from "./xi-check.vue?vue&type=script&lang=js"
import style0 from "./xi-check.vue?vue&type=style&index=0&id=8b153c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b153c8e",
  null
  
)

export default component.exports